import { render } from "./TeamPage.vue?vue&type=template&id=41eb5712"
import script from "./TeamPage.vue?vue&type=script&lang=js"
export * from "./TeamPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__